<!-- 详情弹窗 -->
<template>
  <a-modal
    title="详情"
    :width="640"
    :footer="null"
    :visible="visible"
    @update:visible="updateVisible"
  >
    <a-form
      class="ud-form-detail"
      :label-col="{ sm: { span: 8 }, xs: { span: 6 } }"
      :wrapper-col="{ sm: { span: 16 }, xs: { span: 18 } }"
    >
      <a-row :gutter="16">
        <a-col :sm="12" :xs="24">
          <!-- 电池编号 -->
          <a-form-item label="电池编号:">
            <div class="ud-text-secondary">
              {{ data.batteryCode }}
            </div>
          </a-form-item>
          <!-- 运营商名称 -->
          <a-form-item label="运营商名称:">
            <div class="ud-text-secondary">
              {{ data.operatorName }}
            </div>
          </a-form-item>
          <!-- 型号 -->
          <a-form-item label="型号:">
            <div class="ud-text-secondary">
              {{ data.model }}
            </div>
          </a-form-item>    
          <!-- 仓库名称 -->
          <a-form-item label="仓库名称:">
            <div class="ud-text-secondary">
              {{ data.warehouseName }}
            </div>
          </a-form-item>     
        </a-col>
        <a-col :sm="12" :xs="24">
          <!-- 设备编号 -->
          <a-form-item label="设备号(IMEI):">
            <div class="ud-text-secondary">
              {{ data.batteryImei }}
            </div>
          </a-form-item>         
          <!-- 所属租赁点 -->
          <a-form-item label="所属租赁点:">
            <div class="ud-text-secondary">
              {{ data.pointName }}
            </div>
          </a-form-item>
           <!-- 电池协议 -->
           <a-form-item label="电池协议:">
            <div class="ud-text-secondary">
              {{ data.protocolType }}
            </div>
          </a-form-item>
          
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'batteryDetail',
  emits: ['update:visible'],
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 数据
    data: Object
  },
  methods: {
    /* 更新visible */
    updateVisible(value) {
      this.$emit('update:visible', value)
    }
  }
}
</script>

<style scoped>
</style>
